import { FC, ReactNode } from "react";

import { Box, Flex, HStack, Stack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import Link from "@components/Link";
import responsiveStyle from "@lib/theme/responsiveStyle";

type TOrderInfoItemProps = {
  id: string;
  image: ReactNode;
  title: string;
  isFixedWidthTitle?: boolean;
  isTopAlignedTitle?: boolean;
  description: ReactNode;
  onEditClick?: () => void;
  isEditHidden?: boolean;
  isEditActive?: boolean;
};

const OrderInfoItem: FC<TOrderInfoItemProps> = ({
  id,
  image,
  title,
  isFixedWidthTitle,
  isTopAlignedTitle,
  description,
  onEditClick,
  isEditHidden,
  isEditActive,
}) => {
  const { t } = useTranslation();

  return (
    <HStack spacing="1rem" py={responsiveStyle({ mobile: "0.5rem", desktop: "1.75rem" })}>
      <Flex
        width="3.125rem"
        height="1.75rem"
        justify="center"
        align="center"
        alignSelf={isTopAlignedTitle ? "start" : undefined}
        position="relative"
      >
        {image}
      </Flex>
      <Stack
        direction={responsiveStyle({ mobile: "column", desktop: "row" })}
        spacing={responsiveStyle({ mobile: "0", desktop: "1rem" })}
        flex="1"
        align={responsiveStyle({ mobile: "start", desktop: isTopAlignedTitle ? "start" : "center" })}
        overflow="hidden"
      >
        <Box
          fontSize="0.9rem"
          fontWeight="600"
          sx={{ ...(isFixedWidthTitle && { width: responsiveStyle({ mobile: "100%", desktop: "8rem" }) }) }}
        >
          {title}
        </Box>
        <Box flex="1" fontSize="1rem" fontWeight="300">
          {description}
        </Box>
      </Stack>
      <Box px={responsiveStyle({ mobile: "1rem", desktop: "0" })}>
        {!isEditHidden && (
          <Link
            variant={isEditActive ? "red" : "dark"}
            label={t("order-field-edit")}
            onClick={onEditClick}
            id={`${id}-edit`}
          />
        )}
      </Box>
    </HStack>
  );
};
export default OrderInfoItem;
